
/* injects from baggage-loader */

'use strict';

import { avatars_full, PlayerClass } from '../../index.const';

export default class MainController {
    constructor($log, $state, $rootScope, Session, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.Session = Session;
        this.Dialog = Dialog;

        this.avatars_full = avatars_full;
        this.classes = PlayerClass;
        this.userLevel = this.$rootScope.$currentUser.level;
        this.stageContainer = document.querySelector('body .stage-container');

        this.state = {
            step: 1
        }
    }

    $onInit() {
        this.stages = this.Session.get().stages;
        angular.element(this.stageContainer).addClass('stage-bg-2');

    }

    $onDestroy() {
        angular.element(this.stageContainer).removeClass('stage-bg-2');
        return false;
    }

    toClientMode() {
        let level = this.$rootScope.$currentUser.level;
        let stage = this.stages[level - 1];
        if (stage.completed || stage.locked || level > 2) {
            return false;
        } else {
            this.Dialog.showConfirm('Você escolheu o <b>MODO CLIENTE</b>. <br> Aperte CONFIRMAR para prosseguir.', () => {
                switch (level) {
                    case 1:
                        this.$state.go('main.stage-one');
                        break;
                    case 2:
                        this.$state.go('main.stage-two');
                        break;
                    default:
                        this.$state.go('main.stage-two');
                        break;
                }
            })
        }
    }

    toClientModeNoMenu() {
        let level = this.$rootScope.$currentUser.level;
        let stage = this.stages[level - 1];

        if (stage.completed || stage.locked || level > 2) {
            return false;
        } else {
            switch (level) {
                case 1:
                    this.$state.go('main.stage-one');
                    break;
                case 2:
                    this.$state.go('main.stage-two');
                    break;
                default:
                    this.$state.go('main.stage-two');
                    break;
            }
        }
    }

    toGarcomMode() {
        let level = this.$rootScope.$currentUser.level
        let stage = this.stages[level - 1];
        console.log(stage, level);
        if (stage.locked || stage.completed || level < 3 || level > 5) {
            return false;
        } else {

            this.Dialog.showConfirm('Você escolheu o <b>MODO GARÇOM</b>. <br> Aperte CONFIRMAR para prosseguir.', () => {

                switch (level) {
                    case 3:
                        this.$state.go('main.stage-three');
                        break;
                    case 4:
                        this.$state.go('main.stage-four');
                        break;
                    case 5:
                        this.$state.go('main.stage-fifth');
                        break;
                    default:
                        this.$state.go('main.stage-fifth');
                        break;
                }
            });
        }
    }

    toChefMode() {
        let level = this.$rootScope.$currentUser.level
        let stage = this.stages[level - 1];
        console.log(stage, level);

        if (stage.completed || stage.locked || level < 6) {
            return false;

        } else {

            this.Dialog.showConfirm('Você escolheu o <b>MODO CHEF</b>. <br> Aperte CONFIRMAR para prosseguir.', () => {
                this.$state.go('main.stage-sixth');
            });
        }


    }

    changeStep(){
        this.state.step = 2;
    }

    goTo(route, disabled) {
        if (!disabled) this.$state.go(route);
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/main/main.controller.js